@if(visible()){
<div class="jk-checkbox-border">
  <mat-checkbox [class]="jkClass()"  [(ngModel)]="_value"
   [disabled]="disabled()" text="text"
    (change)="onCheckboxChange($event)">
    {{label()}}
  </mat-checkbox>
  <!-- <mat-checkbox [(ngModel)]="value" [(indeterminate)]="isIndeterminate" (change)="onChange($event)"
    [disabled]="disabled">
    {{label()}}
  </mat-checkbox> -->
</div>
}
